export const isValidEmail = (email: string) => {
  return email
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const isValid24hour = (hour: string): boolean => {
  const regexExp = new RegExp(/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/);
  return regexExp.test(hour);
};

export const getTimeMask = (time: string | undefined): (string | RegExp)[] => {
  return [
    /[0-2]/,
    time?.toString().charAt(0) === '2' ? /[0-3]/ : /\d/,
    ':',
    /[0-5]/,
    /\d/
  ];
};
